var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkyproIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6562 3.51655L0.25 20.0017H20.2069L37.68 0.0136719H22.3906C19.4238 0.0136719 16.6019 1.29337 14.6562 3.51998V3.51655Z",
    fill: "#8AB7E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7576 36.4832L40.1638 20.0015H20.2069L2.7373 39.986H18.0267C20.9935 39.986 23.8154 38.7063 25.761 36.4797L25.7576 36.4832Z",
    fill: "#F5333F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyproIcon);
export default __webpack_public_path__ + "static/media/skypro-icon.c75a939047a6ca33a7e39636a17fb4ac.svg";
export { ForwardRef as ReactComponent };